import { useCallback } from 'react';
import { useRequest } from '@Hooks/useRequest';
import { API } from '@Services';
import { JobSubmissionResponse, GrandchildrenOptionsEnum } from '@Types';
import { SurveyFrameworkEnum } from '@Types/SurveyReportData';
import { ReportFilterParameters } from './useGetFunderReportData';

export const useExportSurveyResponsesForFunder = () => {
  const [fetch, response] = useRequest<JobSubmissionResponse>();

  const exportSurveyResponsesForFunder = useCallback(
    ({
      organization_id,
      framework_name,
      filter_data,
      include_grandchildren,
      org_ids,
    }: {
      organization_id: number;
      framework_name: SurveyFrameworkEnum;
      filter_data: ReportFilterParameters;
      include_grandchildren: GrandchildrenOptionsEnum;
      org_ids: number[];
    }) =>
      fetch(API.paths.export_survey_responses_for_funder, 'put', {
        data: {
          organization_id,
          framework_name,
          ...filter_data,
          include_grandchildren,
          org_ids,
        },
      }),
    [fetch],
  );

  return [exportSurveyResponsesForFunder, response] as const;
};
